import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { ServiceIconV2 } from '@sales-center/components'
import { LEAD_STATUSES } from '@user/components/Leads/LeadCard/typings'
import { OppStatus } from '@user/components/Opportunities/OpportunityCard/typings'
import { ClosingRequirement } from '../../ClosingRequirement'
import { useData } from './hooks/useData'

export type Props = {
  address: string
  branchId: string
  canUpdate: boolean
  entityId: number
  entityType: ENTITY_TYPES
  leadStatus?: LEAD_STATUSES
  onOpenAndAddSvc: () => void
  onOpenSvc: () => void
  oppStatus?: OppStatus
  servicesCount: number
}

export function ServiceRequirements(props: Props) {
  const { canUpdate, entityId, onOpenAndAddSvc, onOpenSvc, servicesCount } =
    props

  const { isComplete, isDisqualifiedLead, oppIsClosed, servicesDisabledText } =
    useData(props)

  return (
    <ClosingRequirement
      requirement="service"
      entityId={entityId}
      count={servicesCount}
      title="Service"
      buttonText="Quote Service"
      linkText="Services Added"
      isDisabledText={servicesDisabledText}
      isComplete={isComplete}
      icon={<ServiceIconV2 />}
      linkClick={onOpenSvc}
      buttonClick={onOpenAndAddSvc}
      isDisabled={!canUpdate || oppIsClosed || isDisqualifiedLead}
    />
  )
}
